import { gql } from "@apollo/client";

export const READ_NOTIFICATION_VISITA = gql`
mutation ReadVisitaNotificacion($idNotificacion: Int!){
    readVisitaNotificacion(idNotificacion: $idNotificacion)
}`;